enum CriterionDataFetchStatusEnum {
  Unknown = 0,
  Success = 1,
  Fail = 2,
}

export default CriterionDataFetchStatusEnum;
